import { AuthGuard } from '@onesource/components';
import { createFileRoute } from '@tanstack/react-router';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { OrderDetailPage } from 'src/pages/billing/order-detail';

export const Route = createFileRoute('/orders/$orderNo')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <OrderDetailPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
